// extracted by css-extract-rspack-plugin
export default {"menu":"menu-G0rgzI","scrollBox":"scrollBox-nsAgxX","item":"item-wrDG56","itemHighlighted":"itemHighlighted-qyS0Vb","field":"field-x9GJVf","input":"input-jgeQJi"};